
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"-461 263 36 36","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M-431.3 282.3h-9.4c-.5 0-.9.4-.9.9v9.2c0 .5.4.9.9.9h9.4c.5 0 .9-.4.9-.9v-9.2c-.1-.6-.4-.9-.9-.9zM-445.3 282.3h-9.4c-.5 0-.9.4-.9.9v9.2c0 .5.4.9.9.9h9.4c.5 0 .9-.4.9-.9v-9.2c-.1-.6-.4-.9-.9-.9zM-445.3 268.8h-9.4c-.5 0-.9.4-.9.9v9.2c0 .5.4.9.9.9h9.4c.5 0 .9-.4.9-.9v-9.2c-.1-.6-.4-.9-.9-.9zM-431.3 268.8h-9.4c-.5 0-.9.4-.9.9v9.2c0 .5.4.9.9.9h9.4c.5 0 .9-.4.9-.9v-9.2c-.1-.6-.4-.9-.9-.9z"}})])
          )
        }
      }
    